const settings = {
  state: {
    // 系统主题
    theme: {
      head: 0,
      logo: 1,
      menu: 1
    },
    textSize: 'small',
    title: ''
  },

  mutations: {
    // 写登录标志
    SET_THEME: (state, value) => {
      state.theme = value
    },
    // 写登录标志
    SET_TEXTSIZE: (state, value) => {
      state.textSize = value
    }
  },

  actions: {
    // 设置网页标题
    SetTitle({ state }, title) {
      state.title = title
      document.title = `${title} - ${process.env.VUE_APP_TITLE}`
    }
  }
}

export default settings
